import apiClient from './core/ApiClient'
import { Timesheet } from 'src/api/Timesheet';
import { TimesheetsStoreRequest } from 'src/api/TimesheetsStoreRequest';
import { TimesheetsListResponse } from 'src/api/TimesheetsListResponse';
import { TimesheetBalance } from '@/api/TimesheetBalance';
import { TimesheetsBalanceListResponse } from '@/api/TimesheetsBalanceListResponse';
import { TimesheetsBalanceStoreRequest } from '@/api/TimesheetsBalanceStoreRequest';
import { StoreResponse } from '@/api/StoreResponse';
import { ApprovalDecisionRequest } from '@/api/ApprovalDecisionRequest';
import { PendingInhabitant } from '@/api/Pending';

const add = (ps: Timesheet): Promise<number> => {
    let payload: TimesheetsStoreRequest = {
        entry: ps
    }
    return apiClient.post<TimesheetsStoreRequest, StoreResponse>(`/api/users/${ps.userId}/timesheets`, payload).then(r => r.id);
}

const update = (ps: Timesheet): Promise<number> => {
    let payload: TimesheetsStoreRequest = {
        entry: ps
    }
    return apiClient.put<TimesheetsStoreRequest, StoreResponse>(`/api/users/${ps.userId}/timesheets`, payload).then(r => r.id);
}

const remove = (userId: number, id: number): Promise<void> => apiClient.delete<void>(`/api/users/${userId}/timesheets/${id}`);

const approve = (userId: number, id: number): Promise<number> =>
    apiClient.put<void, StoreResponse>(`/api/users/${userId}/timesheets/${id}/approve`, undefined).then(r => r.id);

const reject = (userId: number, id: number, reason: string): Promise<number> => {
    const payload: ApprovalDecisionRequest = { reason };
    return apiClient.put<ApprovalDecisionRequest, StoreResponse>(`/api/users/${userId}/timesheets/${id}/reject`, payload).then(r => r.id);
}

const resubmit = (ps: Timesheet): Promise<number> => {
    const payload: TimesheetsStoreRequest = {
        entry: {
            ...ps,
            status: PendingInhabitant,
            decidedBy: null,
            decidedAt: null,
            decisionReason: null
        }
    }
    return apiClient.put<TimesheetsStoreRequest, StoreResponse>(`/api/users/${ps.userId}/timesheets/${ps.id}/resubmit`, payload).then(r => r.id);
}

const approveMonth = (userId: number, year: number, month: number): Promise<number> =>
    apiClient.put<void, StoreResponse>(`/api/users/${userId}/timesheets/${year}/${month}/approve`, undefined).then(r => r.id);

// from, to in ISO 8601 date format
const findAll = (userId: number, from: string, to: string): Promise<Timesheet[]> => apiClient.get<TimesheetsListResponse>(`/api/users/${userId}/timesheets?from=${from}&to=${to}`).then(r => r.results.concat([]));

const addBalance = (ps: TimesheetBalance): Promise<number> => {
  let payload: TimesheetsBalanceStoreRequest = {
    entry: ps,
  };
  return apiClient
    .post<TimesheetsBalanceStoreRequest, StoreResponse>(
      `/api/users/${ps.userId}/timesheets/balance`,
      payload
    )
    .then((r) => r.id);
};

const updateBalance = (ps: TimesheetBalance): Promise<number> => {
  let payload: TimesheetsBalanceStoreRequest = {
    entry: ps,
  };
  return apiClient
    .put<TimesheetsBalanceStoreRequest, StoreResponse>(
      `/api/users/${ps.userId}/timesheets/balance`,
      payload
    )
    .then((r) => r.id);
};

const removeBalance = (userId: number, id: number): Promise<void> =>
  apiClient.delete<void>(`/api/users/${userId}/timesheets/balance/${id}`);

const findAllBalance = (userId: number): Promise<TimesheetBalance[]> =>
  apiClient
    .get<TimesheetsBalanceListResponse>(`/api/users/${userId}/timesheets/balance`)
    .then((r) => r.results.concat([]));


export const timesheetService = {
    add,
    update,
    remove,
    approve,
    reject,
    resubmit,
    approveMonth,
    findAll,
    addBalance,
    updateBalance,
    removeBalance,
    findAllBalance
}
